// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__Krjwk","colLeft":"App_colLeft__r9i-a","colRight":"App_colRight__FmaET","logo":"App_logo__XQjjs","text":"App_text__2ton+","trophy":"App_trophy__+cMVv"};